var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcon = function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 62 41"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m45.105 29.406 14.596-14.595-8.113-8.113-14.639 14.594V.633H25.448v20.619L10.894 6.697 2.739 14.81l14.595 14.595H.522v11.501h18.82a11.494 11.494 0 0 0 11.501-11.501h-9.996v-.752c5.521 0 9.954-4.475 9.954-9.954h.752c0 5.521 4.476 9.954 9.954 9.954v.752h-9.912c0 6.357 5.145 11.501 11.5 11.501h18.82v-11.5z"
  })));
};
export default SvgIcon;